
<div class="modal">
  <div class="modal-content" [style.width]="contentStyles.width" [style.height]="contentStyles.height">
    <div class="modal-title">
      <span class="title">{{ modalTitle }}</span>
      <span class="close" (click)="onClose()">&times;</span>
    </div>
    <hr/>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
